import type { VariantInterpretation } from '@/features/patient-record/types';

/**
 * Display order for variant lists — pathogenic-first so the most
 * actionable rows surface at the top of the variants tooltip.
 */
export const VARIANT_SEVERITY_ORDER: Record<VariantInterpretation, number> = {
  Pathogenic: 0,
  'Likely Pathogenic': 1,
  VUS: 2,
  'Likely Benign': 3,
  Benign: 4,
};

/** Short labels (P / LP / VUS / LB / B) used in the variants tooltip pills. */
export const INTERPRETATION_SHORT: Record<VariantInterpretation, string> = {
  Pathogenic: 'P',
  'Likely Pathogenic': 'LP',
  VUS: 'VUS',
  'Likely Benign': 'LB',
  Benign: 'B',
};

/**
 * Tooltip pill background per interpretation, mirroring the design-system
 * tokens used by `<Badge>` in `VariantRow` so the tooltip and row read the
 * same: P/LP → destructive (red), VUS → secondary (sky blue),
 * LB/B → muted (neutral). Avoids the raw amber/orange palettes that didn't
 * match elsewhere in the app and lost contrast at this font size.
 */
export const INTERPRETATION_TONE: Record<VariantInterpretation, string> = {
  Pathogenic: 'bg-destructive/15 text-destructive',
  'Likely Pathogenic': 'bg-destructive/10 text-destructive',
  VUS: 'bg-secondary/15 text-secondary',
  'Likely Benign': 'bg-muted text-muted-foreground',
  Benign: 'bg-muted text-muted-foreground',
};
